import React, {useEffect, useRef, useState} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t, getLanguage} from 'react-switch-lang';
import {
    getAllSubRisksCauses,
    createSubRisksCauses,
    deleteSubRisksCauses,
  updateSubRisksCauses,
  getAllRisksCauses
} from '../../../services/SubRisksCausesService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from '../Metodologies/plus.png';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
import Swal from "sweetalert2";



const SubRisksCauses = () => {

    const [subRisksCauses, setSubRisksCauses]= useState([]);
    const [risksCauses, setRisksCauses]= useState([]);
    const [query, setQuery]= useState();
    const addButton = useRef();
    
    useEffect(() => {
        const fetchData = async () => {
            try{
                const {data} = await getAllSubRisksCauses();
                setSubRisksCauses(data);

            }catch(err){}
        };
        fetchData();       
    }, [])
    useEffect(() => {
        const fetchData = async () => {
          try {
            const {data} = await getAllRisksCauses();
            setRisksCauses(data);
          } catch (err) {}
        };
        fetchData();
      }, []);


      const formatedRisksCauses = risksCauses.map((d) => ({
        label: getLanguage() === "eng" ? d.nameEn : d.name,
        value: d.id,
      }));

    const columns = [
        {
            dataIndex: 'name',
            title: t('subRisksCauses.name'),
            editable: true,
            placeholder: t('subRisksCauses.placeholder.name'),
            rules: [
              {required: true, message: t('message.fieldRequired')},
              {
                pattern: validNameandNumberEngMneRegex,
                message: t('message.fieldNotValid'),
              },
              {min: 3, message: t('message.min', {min: 3})},
              {max: 255, message: t('message.max', {max: 255})},
              { whitespace: true,
                message: t('message.fieldNotValid')
              },
            ],
        },
            {
                dataIndex: 'nameEn',
                title: t('subRisksCauses.nameEn'),
                editable: true,
                placeholder: t('subRisksCauses.placeholder.nameEn'),
                rules: [
                  {required: true, message: t('message.fieldRequired')},
                  {
                    pattern: validNameandNumberEngMneRegex,
                    message: t('message.fieldNotValid'),
                  },
                  {min: 3, message: t('message.min', {min: 3})},
                  {max: 255, message: t('message.max', {max: 255})},
                  { whitespace: true,
                    message: t('message.fieldNotValid'),
                  },
                ],
              },
              {
                dataIndex:'riskCauseId', 
                placeholder: t('subRisksCauses.placeholder.select'),
                nestedKey: getLanguage() === "eng" ? 'nameEn' : 'name',
                title: t('subRisksCauses.risksCauses'),
                editable: false,
                inputType: 'customSelect',
                options: formatedRisksCauses,
                rules: [
                  {required: true, message: t('message.fieldRequired')},
                 
                 
                ],
                render: (value) => {
                  const riskCauses = formatedRisksCauses?.find((d) => d.value === value);
                  return riskCauses?.label;
                },
                
              }
          
    ];

    const onUpdate = async (data, editingRecord, form) => {
        data.id = editingRecord.id;
        data.nameEn = data.nameEn.trim();
        data.name = data.name.trim();
        data.riskCauseId= editingRecord?.riskCauseId
        try {
          const response = await updateSubRisksCauses(data);
          if (response.status === 200) {
            Toast.fire({
              title: t('subRisksCauses.message.updateSuccess', {
                entity: t('subRisksCauses.subRisksCause'),
              }),
              icon: 'success',
            });
          }
          return response;
        } catch (err) {
          if (err.response.data.detail === 'name') {
            form.setFields([
              {
                name: 'name',
                errors: [t('message.subRiskCauseExists')],
              },
            ]);
          }
          if (err.response.data.detail === 'name_en') {
            form.setFields([
              {
                name: 'nameEn',
                errors: [t('message.subRiskCauseExists')],
              },
            ]);
          }
        }
      };
    
      return (
        <div className="users administration-template">
          <div className="w-100 d-flex justify-content-between mb-4">
            <div className="search-field">
              <SearchBox
                placeholder={t('subRisksCauses.placeholder.search')}
                setQuery={setQuery}
              />
            </div>
          </div>
          <CustomTable
            api="/risk-sub-causes"
            query={query}
            queryParamName="name.contains"
            columns={columns}
            sort={getLanguage() === "eng" ? "nameEn" : "name"}
            methods={{onUpdate}}
            addButtonRef={addButton}
            hideDeleteAndDeactivation={true}
          />
        </div>
      );

}

export default SubRisksCauses;